import { render, staticRenderFns } from "./PageListTemplate.vue?vue&type=template&id=0570851a&"
import script from "./PageListTemplate.vue?vue&type=script&lang=js&"
export * from "./PageListTemplate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports